import { createSelector } from "@reduxjs/toolkit";

import { isBlockedAdminRoute } from "ias/deployment-adapter/route-blocklist";
import type { State } from "metabase/redux/store";

// IAS overlay: hide admin top-nav tabs whose routes are blocklisted. Filtering
// here (instead of relying solely on the `metabase/selectors/admin$` alias in
// `frontend/src/ias/deployment-adapter/ias-aliases.js`) guarantees the filter
// applies even in build paths that skip alias resolution (test harness, SSR
// of static viz, etc.). Wrapped in `createSelector` so we return the same
// filtered-array reference when `state.admin.app.paths` hasn't changed — a
// plain `.filter(...)` returns a fresh array on every call and trips
// react-redux's "returned a different result" warning.

export const getAdminPaths = createSelector(
  (state: State) => state.admin?.app?.paths ?? [],
  (paths) => paths.filter((item) => !isBlockedAdminRoute(item.path)),
);
